import { render, staticRenderFns } from "./toggleButton.vue?vue&type=template&id=4ff1543a"
import script from "./toggleButton.vue?vue&type=script&lang=js"
export * from "./toggleButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports